export default class ApiAccessKeys {

  constructor( api ) {
    this.api = api
  }
  
  /**
   * List api access keys.
   */
  list( options ) {
    return this.api.get( options )
  }

  /**
   * Create api access key.
   */
  create( data, options ) {
    return this.api.post( data, options )
  }
}
